
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="/logo/pm-logo-white.svg"
              alt="PrimeMeridian Travel"
              className="h-20 w-auto mb-4"
            />
            <p className="text-gray-300 mb-4">
              Exploring the world <br />together for 13+ years—across generations
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/primemeridian.travel/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-instagram-line w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a href="https://www.facebook.com/profile.php?id=61572538649614" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-facebook-fill w-6 h-6 flex items-center justify-center"></i>
              </a>
              <a href="https://www.linkedin.com/company/primemeridian-travel/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-linkedin-fill w-6 h-6 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* Explore Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Explore</h4>
            <ul className="space-y-2">
              <li><a href="/experience" className="text-gray-300 hover:text-white transition-colors">Experience</a></li>
              <li><a href="/cruises" className="text-gray-300 hover:text-white transition-colors">Cruises</a></li>
              {/* <li><a href="group-tours" className="text-gray-300 hover:text-white transition-colors">Group Tours</a></li> */}
              <li><a href="/careers" className="text-gray-300 hover:text-white transition-colors">Careers</a></li>
            </ul>
          </div>

          {/* About Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">About</h4>
            <ul className="space-y-2">
              <li><a href="/about" className="text-gray-300 hover:text-white transition-colors">About Us</a></li>
              <li><a href="/terms" className="text-gray-300 hover:text-white transition-colors">Terms & Conditions</a></li>
              {/* <li><a href="#" className="text-gray-300 hover:text-white transition-colors">FAQ</a></li> */}
              <li><a href="/privacy-policy" className="text-gray-300 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            ©2026 by Prime Meridian Travel. Proudly created with Prime Meridian Travel Co.
          </p>
        </div>
      </div>
    </footer>
  );
};
